var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({ref:"numField",attrs:{"rules":_vm.rulesApplied},model:{value:(_vm.num),callback:function ($$v) {_vm.num=$$v},expression:"num"}},'v-text-field',[_vm.$attrs, _vm.$props],false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }